<div mdbModal #modal="mdbModal" class="modal fade" id="modal" tabindex="-1" role="dialog" [config]="{ignoreBackdropClick: true}">
  <div class="modal-dialog cascading-modal modal-lg " role="document">
    <div class="modal-content">
      <div class="modal-header indigo white-text">
        <h4 class="title">{{ Localization.LicenseAgreement | translate }}</h4>
      </div>
      <div class="modal-body h-50-vh">
        <form (ngSubmit)="onSubmit()" #detailsForm="ngForm">
          <div class="row">
            <div class="col-md-12 col-lg-12">
              <div class="license" [innerHTML]="content">
              </div>
            </div>
          </div>
          <div class="row justify-content-center mt-3">
            <div class="form-check">
              <input class="form-check-input" mdbInput type="checkbox" id="terms"
                (change)="onAgreeToTermsChange($event.target.checked)"/>
              <label class="form-check-label" for="terms">{{Localization.IHaveReadAndAgreeToTheLicenseAgreementAbove | translate}}</label>
            </div>
          </div>
          <div class="d-flex justify-content-center mt-3 mb-3">
            <button type="submit" class="btn btn-amber" data-dismiss="modal" [disabled]="!agreedToTerms" mdbRippleRadius>
              {{ Localization.GetStarted | translate }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
